export enum FeeType {
    Log = 'log',
    Automatic = 'automatic',
}
